export default {
  // DirectTeachingActivityView
  editActivity: 'Edit Direct Teaching Activity',
  deleteActivity: 'Delete Direct Teaching Activity',
  deleteActivityConfirmation: 'Are you sure you want to delete the Direct Teaching Activity?',
  activityDeleted: 'Direct Teaching Activity deleted.',

  // DirectTeachingActivityForm
  activityCreated: 'Direct Teaching Activity created.',
  activityUpdated: 'Direct Teaching Activity updated.',
}
